import styled from 'styled-components'

export const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	row-gap: 8px;
	margin: 0 0 16px;
`
